import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Sidebar from '../Sidebar';
import Welcome from './Welcome';
import UserMetrics from './UserMetrics';
import MarketplaceMetrics from './MarketplaceMetrics';

const DashboardLayout = ({ onLogout }) => {
  return (
    <div className='d-flex w-100 overflow-hidden'>
      <div className='asidebar'>
        <Sidebar />
      </div>
      <div className='main-content' style={{ flex: 1, overflow: 'auto', padding: '20px' }}>
        <Routes>
          <Route index element={<Welcome />} />
          <Route path="user-metrics" element={<UserMetrics />} />
          <Route path="marketplace-metrics" element={<MarketplaceMetrics />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </div>
    </div>
  );
};

export default DashboardLayout;

